import React from 'react';
import './home.less';

import img_dibu_qq from './static/new_img/08qq.png';
import img_dibu_pho from './static/new_img/09.png';
import img_dibu_xian from './static/new_img/10.png';
import img_dibu_email from './static/new_img/11.png';
import img_weixin from './static/new_img/13weixin.png';
import img_link from './static/new_img/14.png';


class HomeBottom extends React.Component {


    get_year = () =>{
        return  new Date().getFullYear();
    }


    constructor(props) {
        super(props);
        this.state = {
            year:this.get_year()
        };
    }


    render() {
        return(
            <div id='Fifth_all'>
                <div id='Fifth'>
                    <div id='five_top' className="flex-container five_top">

                        <div id='five_top_left' className="flex-container">
                            <div id='five_top_left_child'>
                                <p id="five_top_left_p1" className="Subheading_3">关于魔宝</p>
                                <a className='title_bottom' href="http://doc.maxplugin.com/2076093" target="_blank"><p id="five_top_left_p2" className='text_introduce'>安装说明</p></a>
                                <a className='title_bottom' href="http://doc.maxplugin.com/1470932" target="_blank"><p id="five_top_left_p2" className='text_introduce'>常见问题</p></a>
                                <a className='title_bottom' href="http://doc.maxplugin.com/" target="_blank"><p id="five_top_left_p2" className='text_introduce'>魔宝教程</p></a>
                                <a className='title_bottom' href="http://doc.maxplugin.com/1939444" target="_blank"><p id="five_top_left_p2" className='text_introduce'>更新日志</p></a>
                            </div>
                        </div>

                        <div id='five_top_right'>
                            <div id='right_top' className="flex-container">
                                <img id="img_weixin" src={img_weixin} alt=""/>
                            </div>

                            <div id='right_buttom' style={{ textAlign:'left' }}>
                                <div id="five_grand_v1">
                                    <span id="wx" className="text_contact">扫码关注微信</span>
                                </div>

                                <div style={{ position:'relative',top:'10px' }}>
                                    <img id="img_dibu_pho" src={img_dibu_pho} alt=""/>
                                    <span className="text_customer_service">4006-888-245</span>
                                </div>

                                <div style={{ position:'relative',top:'20px' }}>
                                    <img id="img_dibu_qq" src={img_dibu_qq} alt=""/>
                                    <span className="text_customer_service">客服: 3001188325</span>
                                </div>

                                <div style={{ position:'relative',top:'30px' }}>
                                    <img id="img_dibu_email" src={img_dibu_email} alt=""/>
                                    <span className="text_customer_service">marketing@xsuperzone.com</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="div_fifth" >
                        <div className="text_link text_link_line1" style={{ position:'relative',top:'50px'}}>
                            <img id="img_link" src={img_link} alt=""/>
                            友情链接:
                            <a className='title_bottom' href="http://www.xrender.com/"  target="_blank">渲云渲染</a> |
                            <a className='title_bottom' href="http://www.3dmax8.com" target="_blank">3dmax下载</a> |
                            <a className='title_bottom' href="http://www.emoding.com/" target="_blank">魔叮建筑众包平台</a> |
                            <a className='title_bottom' href="http://xiazai.zol.com.cn/" target="_blank">ZOL下载</a> |
                            <a className='title_bottom' href="http://www.jisuxz.com/" target="_blank">极速下载</a> |
                            <a className='title_bottom' href="http://www.ddooo.com/" target="_blank">多多软件站</a> |
                            <a className='title_bottom' href="http://www.opdown.com/" target="_blank">欧普软件</a> |
                            <a className='title_bottom' href="http://www.downza.cn/" target="_blank">下载之家</a> |
                            <a className='title_bottom' href="https://www.5down.net/" target="_blank">第五下载</a> |
                            <a className='title_bottom' href="http://www.greenxf.com/" target="_blank">绿色先锋下载</a> |
                            <a className='title_bottom' href="http://www.element3ds.com/" target="_blank">微元素</a> |
                            <a className='title_bottom' href="http://www.xy-share.com" target="_blank">3D模型</a> |
                            <a className='title_bottom' href="http://www.3dkk.com/" target="_blank">3D卡卡素材分享</a> |
                            <a className='title_bottom' href="http://www.cgdashi.com/" target="_blank">cg大师网</a> |
                            <a className='title_bottom' href="http://www.c4dlx.com" target="_blank">九方格设计</a> |
                            <a className='title_bottom' href="http://www.8hmx.com/" target="_blank">八号模型</a> |
                            <a className='title_bottom' href="https://www.jb51.net/" target="_blank">脚本之家</a> |
                            <a className='title_bottom' href="http://www.itopdog.cn/" target="_blank">软件盒子</a> |
                            <br />
                            <a className='title_bottom' href="http://www.xue51.com/" target="_blank">软件学堂</a> |
                            <a className='title_bottom' href="https://www.52z.com/" target="_blank">飞翔下载</a> |
                            <a className='title_bottom' href="https://www.haote.com/" target="_blank">好特下载</a> |
                            <a className='title_bottom' href="http://www.xpgod.com/" target="_blank">系统天堂</a> |
                            <a className='title_bottom' href="http://www.33lc.com/" target="_blank">绿茶软件下载</a>
                        </div>

                        <img id="img_dibu_xian" src={img_dibu_xian} alt=""/><br/>
                        <a className='title_bottom' href="https://beian.miit.gov.cn" target="_blank"><span className="text_company text_company_left">Copyright 2017-{this.state.year} 江苏赞奇科技股份有限公司 | 苏ICP备11007458号  All Reserved</span></a>
                    </div>
                </div>
            </div>
        )
    }
}

export default HomeBottom;
